import { getFeatureAttributes } from '@juvare/common-js/feature-flags';
import React from 'react';
import { FeatureFlagConfigChangeContext } from '../CommonProvider/FeatureFlagConfigChangeContext';
export function useFeatureFlag(component, flag) {
    const { configKey } = React.useContext(FeatureFlagConfigChangeContext);
    return React.useMemo(() => {
        const attributes = getFeatureAttributes(component, flag);
        return {
            enabled: attributes != null,
            attributes,
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [component, flag, configKey]);
    // Variable configKey is added to dependencies because we specifically want to recalculate feature flag config values when it changes.
    // Eslint ignore comment is needed because eslint sees configKey variable is not used.
}
